import React from "react";
import { useActor } from "@xstate/react";
import AutoCompleteInput from "../AutoCompleteInput";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";
import { BalancedStepSubtitle } from "../BalancedStepSubtitle";

const BusinessNameStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const companyValue = formData[SignUpFormField.Company];

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.Company]: value },
    });
  };

  const handleSubmit = () => {
    send({ type: "NEXT" });
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="What's the name of your business?" />
        <BalancedStepSubtitle subtitle="Search your business name. If it's not listed, you'll be able to add it manually." />
      </div>

      <div className="tw-space-y-4">
        <label
          htmlFor={SignUpFormField.Company}
          className="tw-block tw-text-sm tw-text-gray-800"
        >
          Business Name
        </label>
        <AutoCompleteInput
          inputId={SignUpFormField.Company}
          value={companyValue}
          placeholder="Enter your business name"
          onChange={handleChange}
          onSelect={handleSubmit}
        />
      </div>
    </>
  );
};

export default BusinessNameStep;
